import * as React from 'react';
import classnames from 'classnames';

const renderProgressBar = (max, value)=>/*#__PURE__*/ React.createElement("progress", {
        className: "progress-bar__value",
        max: max,
        value: value
    }, value && `${value}%`)
;
const ProgressBar = ({ label , max , value , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('progress-bar', className)
    }, label ? /*#__PURE__*/ React.createElement("label", {
        className: "progress-bar__label"
    }, label, renderProgressBar(max, value)) : renderProgressBar(max, value))
;
var ProgressBar$1 = ProgressBar;

export { ProgressBar$1 as default };
//# sourceMappingURL=ProgressBar.js.map
